export class FileExpirationStatus {
  static valid = 1;
  static expireSoon = 2;
  static expired = 3;
}
